import { Components, Theme } from "@mui/material";

export const MuiSvgIcon: Components<Omit<Theme, "MuiSvgIcon">>["MuiSvgIcon"] = {
  styleOverrides: {
    fontSizeSmall: {
      fontSize: 16,
    },
    fontSizeMedium: {
      fontSize: 20,
    },
  },
};
